export const SourceType = {
  S3: 'S3',
  SFTP: 'SFTP'
};
